export default __webpack_public_path__ + "static/media/radio_no_select.0ddcb835.svg";